import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService, CoreProxyService, CoreTypes, IMyDate } from 'common-cloudstudio';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-shared-asset-tracking',
  templateUrl: './shared-asset-tracking.component.html',
  styleUrls: ['./shared-asset-tracking.component.scss']
})
export class SharedAssetTrackingComponent implements OnInit, OnDestroy {

  genericToken: string = null;
  accessToken: string = null;
  facilityID: number;
  clientID: number;
  assets: number[] = [];
  drivers: number[] = [];
  geozones: number[] = [];
  returnRoute: boolean = false;
  date: IMyDate|null;
  alarmFilters: CoreTypes.AssetTrackingAlarmFilters =  new CoreTypes.AssetTrackingAlarmFilters();
  subscriptions: Subscription[] = [];

  constructor( 
    public appService: AppService,
    private activatedRoute: ActivatedRoute,
    private coreProxyService: CoreProxyService,
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(this.activatedRoute.params.subscribe(params => {
      if(params.genericToken){
        this.genericToken = params.genericToken;
        this.getSharedAssetTracking();
      }
    })); 
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getSharedAssetTracking() {
    this.coreProxyService.AssetService.GetSharedAssetTrackingData(
      this.genericToken,
      res => {
        setTimeout(() => {
          this.accessToken = res.AccessToken;
        }, 500)
        this.clientID = res.ClientID;
        this.facilityID = res.FacilityID;
        this.assets = res.Assets;
        this.geozones = res.Geozones;
        this.returnRoute = res.ReturnRoute;
        this.drivers = res.Drivers;
        this.date = res.Date ? this.parseDate(res.Date) : null;
        this.alarmFilters = res.AlarmFilters;
        const expirationTime = ((res.AccessTokenExpirationSeconds*75)/10)*100;
        setTimeout(() => this.getSharedAssetTracking(), expirationTime);
      },
      err => {
        setTimeout(() => this.getSharedAssetTracking(), 15000);
        this.appService.showException(err);
      }
    );
  }

  parseDate(date: CoreTypes.DateTimeDT) {
    return {
      year: date.Date.Year,
      month: date.Date.Month,
      day: date.Date.Day,
    }
  }
}
